export default {
  topicDetail_just_look_essence:'只看精华',
  topicDetail_follow_circle:'关注圈子',
  topicDetail_follow_num:"{transformNum}个关注",
  topicDetail_no_circle_intro:"暂无圈子介绍",
  topicDetail_latest_publish:'按最新发布',
  topicDetail_found:"下架后，可在“我的帖子-我管理的帖子”中找到该内容，并恢复上架，确定要下架吗？"
}
